import client from '../client';

export const FETCH_LOGGED_IN_USER = 'FETCH_LOGGED_IN_USER';
export function fetchLoggedInUser() {
  return {
    type: FETCH_LOGGED_IN_USER,
    promise: client.get('user'),
  };
}
